import styled from 'styled-components';

export const DivContainer = styled.div`
  height: 88vh;
    width: -webkit-fill-available;
  background-color: rgb(255, 255, 255);
  margin: 1%;
  padding: 16px;
  box-sizing: border-box;
  border-radius: 8px;
  overflow-x: auto;
  box-shadow: 0px 1.5px 2px 0px rgba(16, 24, 40, 0.10);
  border: 1px solid var(--Neutral-Gray-Gray-100, #E0E2E7);
  @media only screen and (max-width: 1100px) {
    height: auto;
    padding: 10px;
    margin: 0;
    border-radius: 0;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
`;

export const ModalContent = styled.div`
  background-color: #fff;
  width: auto;
  border-radius: 5px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  z-index: 6;
`;

export const CloseButton = styled.button`
  position: relative;
  top: -6px;
  right: 0%;
  left: 92%;
  background: none;
  border: none;
  height: auto;
  font-size: 16px;
  width: auto;
  cursor: pointer;
`;

export const EventForm = styled.div`
  label {
    display: block;
    margin-bottom: 5px;
  }

  input {
    width: 100%;
    margin-bottom: 10px;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
